// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/sal/sorgente?commessaId',
    requestBody: null,
    response: '{"success":true,"data":{"commessa":{"id":"number","numero":"string","descrizione":"string|null","clienteRagioneSociale":"string|null","societaId":"number"},"ordini":[{"id":"number","numero":"string","stato":"string","destinatarioOrdine":"string|null","dataConferma":"string|null","totale":"number|null","righe":[{"rigaOrdineId":"number","ordinePos":"number","tipoRiga":"string","descrizione":"string","unitaMisura":"string|null","quantitaTotale":"number|null","quantitaPrecedente":"number","residua":"number|null","prezzoUnitario":"number","importoNetto":"number|null"}]}],"extra":[{"rigaDistintaExtraId":"number","distintaEtichetta":"string","distintaTipo":"MERCE|LAVORAZIONI","descrizione":"string","unitaMisura":"string|null","quantitaTotale":"number","quantitaPrecedente":"number","residua":"number"}],"acconti":[{"proformaAccontoId":"number","numero":"string","totale":"number","dataPagamento":"string|null","ordineId":"number|null","stornato":"number","residuoStornabile":"number"}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/sal',
    requestBody: '{"commessaId":"number","righe":[{"rigaOrdineId":"number?","rigaDistintaExtraId":"number?","descrizione":"string","quantitaTotale":"number|null","quantitaPrecedente":"number","quantitaCorrente":"number","prezzoUnitario":"number","importoCorrente":"number"}],"storni":[{"proformaAccontoId":"number","importoStornato":"number"}]}',
    response: '{"success":true,"data":{"id":"number"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
